import { TextField } from '@mui/material';
import { styled } from '@mui/material/styles';

export const RootStyled = styled(TextField)(({ theme }) => ({
  '& .MuiInputLabel-shrink, & fieldset': {
    fontSize: '16px',
  },
  '& .MuiIcon-root': {
    alignItems: 'center',
    color: theme.palette.global.gray,
    display: 'flex',
    height: '56px',
    justifyContent: 'center',
    transition: '0.3s',
    width: '56px',
    '&:hover': {
      color: theme.palette.global.lightgray,
      cursor: 'pointer',
    },
  },
  '& .MuiOutlinedInput-adornedEnd': {
    padding: '0',
  },
  '& .MuiInputAdornment-positionEnd': {
    margin: '0',
  },
}));
